<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-form
        @submit.prevent="dataSave()"
        ref="form"
        v-model="valid"
        lazy-validation
    >
      <v-row>
        <v-col cols="12" md="6">
          <v-card :loading="loading" class="my-6">
            <template slot="progress">
              <v-progress-linear height="10" indeterminate></v-progress-linear>
            </template>
            <template>
              <v-card-title>{{ doctor.dr_id }}</v-card-title>

              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                  <tr>
                    <td>Doctor Name</td>
                    <td>{{ doctor.dr_name }}</td>
                  </tr>

                  <tr>
                    <td>Phone</td>
                    <td>{{ doctor.dr_phone }}</td>
                  </tr>
                  <tr>
                    <td>Email Address</td>
                    <td>{{ doctor.dr_email }}</td>
                  </tr>
                  <tr>
                    <td>Degree</td>
                    <td v-html="doctor.dl_designation">
                      {{ doctor.dl_designation }}
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{{ doctor.dr_address }}</td>
                  </tr>
                  <tr>
                    <td>Type</td>
                    <td>{{ doctor.dr_type }}</td>
                  </tr>
                  <tr>
                    <td>Room Number</td>
                    <td>{{ doctor.room_no }}</td>
                  </tr>
                  <tr>
                    <td>Fee</td>
                    <td>
                      <span>Con. Fee: {{ doctor.consultancy_fee }}</span><br>
                      <span>Re Con. Fee: {{ doctor.re_consultancy_fee }}</span><br>
                      <span>ROP Con. Fee: {{ doctor.rop_consultancy_fee }}</span><br>
                      <span>Re ROP Con. Fee: {{ doctor.rop_re_consultancy_fee }}</span><br>
                      <span>Myopia ROP Con. Fee: {{ doctor.myopia_consultancy_fee }}</span><br>
                      <span>Re Myopia Con. Fee: {{ doctor.myopia_re_consultancy_fee }}</span><br>
                    </td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>{{ doctor.status == 1 ? 'Active':'Inactive' }}</td>
                  </tr>
                  <tr>
                    <td>Appointment Status</td>
                    <td>{{ doctor.appointment_status == 1 ? 'Online':'Offline' }}/Oncall</td>
                  </tr>
                  <tr>
                    <td>Appointment Time</td>
                    <td>
                      <span>Start Time: {{ doctor.appointment_start_time }}</span><br>
                      <span>End Time: {{ doctor.appointment_end_time }}</span><br>
                    </td>
                  </tr>
                  <tr>
                    <td>Appointment Off Days</td>
                    <td>
                      <div v-for="date in doctor.appointment_off_dates" :key="date">
                        <v-chip color="red" v-if="(date >= today_date)">
                          {{ date }}
                        </v-chip>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>Created Date</td>
                    <td>{{ format_date(doctor.created_at) }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
            <v-divider class="mx-4"></v-divider>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title> New Time Schedule </v-card-title>

            <v-col cols="12">
              <v-select
                  :items="days"
                  v-model="schedule_data.day"
                  required
                  label="Day of Week"
                  outlined
                  dense
              ></v-select>
            </v-col>
            <template>
              <v-row justify="space-around" align="center">
                <v-col style="width: 250px; flex: 0 1 auto">
                  <h2>Start:</h2>
                  <v-time-picker
                      width="150"
                      v-model="schedule_data.start"
                      :max="schedule_data.end"
                      scrollable
                      ampm-in-title
                      format="ampm"
                      full-width
                  ></v-time-picker>
                </v-col>
                <v-col style="width: 250px; flex: 0 1 auto">
                  <h2>End:</h2>
                  <v-time-picker
                      width="150"
                      v-model="schedule_data.end"
                      :min="schedule_data.start"
                      scrollable
                      ampm-in-title
                      format="ampm"
                      full-width
                  ></v-time-picker>
                </v-col>
              </v-row>
            </template>
            <v-col cols="12" justify="space-around" align="center">
              <v-text-field
                  v-model="schedule_data.note"
                  label="Note"
                  outlined
              ></v-text-field>
              <v-btn
                  color="blue"
                  label
                  link
                  outlined
                  pill
                  :disabled="buttonSubmit"
                  type="submit"
              >
                Save
              </v-btn>
              <v-btn
                  color="blue"
                  label
                  link
                  outlined
                  pill
                  :disabled="buttonUpdate"
                  type="submit"
              >
                Save Changes
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
      </v-row>
      <v-card>
        <v-card-title>
          Schedule List
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="desserts"
            class="elevation-1"
            :search="search"
        >
          <template v-slot:item.actions="{ item }">
            <div>
              <v-icon color="blue" v-on:click="editSchedule(item)"
              >mdi-pencil-box</v-icon
              >
            </div>
          </template>
        </v-data-table>

        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-card>
    </v-form>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../js/setup";
import moment from "moment";
import PermissionName from "@/js/PermissionName";
export default {
  data() {
    return {
      today_date : moment().format('YYYY-MM-DD'),
      days: [
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
      ],
      doctor_id: this.$route.params.id,
      search: "",
      doctor: {},
      loading: true,
      valid: true,
      buttonSubmit: false,
      buttonUpdate: true,
      schedule_data: {
        id: null,
        day: null,
        doctor_id: this.$route.params.id,
        note: null,
        start: "10:00:00",
        end: "21:00:00",
        user_id: localStorage.getItem("userId"),
      },
      desserts: [],
      headers: [
        { text: "Day of Week", value: "day_of_week" },
        { text: "Start Time", value: "start_time" },

        { text: "End Time", value: "end_time" },
        { text: "Note", value: "note" },
        { text: "Status", value: "schedule_status" },

        { text: "Action", value: "actions", sortable: false },
      ],
      errors: "",

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Doctors",
          disabled: false,
          href: "/doctors",
        },
        {
          text: "Details",
          disabled: true,
          href: "patient-details",
        },
      ],
    };
  },

  // Fetches posts when the component is created.

  created() {
    this.permissionExists(PermissionName.DOCTOR_LIST);
    this.initialize();
    this.doctorSchedule();
  },
  methods: {
    initialize() {
      atshq
          .get("doctors/" + this.doctor_id)
          .then((response) => {
            this.loading = false;
            this.doctor = response.data;
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log(e);
          });
    },
    doctorSchedule() {
      atshq
          .get("doctor-schedules?doctor_id=" + this.doctor_id)
          .then((response) => {
            this.loading = false;
            this.desserts = response.data.data;
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log(e);
          });
    },

    dataSave() {
      if (this.$refs.form.validate()) {
        let submitUrl = this.schedule_data.id
            ? "doctor-schedules/" + this.schedule_data.id
            : "doctor-schedules";
        if (this.schedule_data.id) {
          atshq
              .put(submitUrl, {
                schedule_data: this.schedule_data,
              })
              .then((response) => {
                // JSON responses are automatically parsed.
                this.doctorSchedule();
                this.loadingstatus = false;
                this.$noty.success(response.data.messages);
              })
              .catch((e) => {
                // this.errors.push(e);
                this.$noty.error("Oops, " + e.data.messages);
                this.$noty.error(" " + e);
              });
        } else {
          atshq
              .post(submitUrl, {
                schedule_data: this.schedule_data,
              })
              .then((response) => {
                // JSON responses are automatically parsed.
                this.loadingstatus = false;
                this.$noty.success(response.data.messages);
              })
              .catch((e) => {
                // this.errors.push(e);
                this.$noty.error("Oops, " + e.data.messages);
                this.$noty.error(" " + e);
                console.log(e);
              });
        }
      } else {
        console.log("error");
      }
    },
    format_date(value){
      if (value) {
        return moment(String(value)).format('DD MMMM YYYY')
      }
    },
  },
};
</script>